import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  map: {
    width: '100%',
    height: 240,
    borderRadius: 10,
    overflow: 'hidden',
  },

  detailsForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xxl,

    [theme.breakpoints.up('laptop')]: {
      marginBottom: SPACES.xl,
    },
  },

  radioButtons: {
    '&&': {
      padding: `${SPACES.xs} ${SPACES.xxl} ${SPACES.s}`,

      width: '100%',

      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.custom.grey}`,

      [theme.breakpoints.down('tablet')]: {
        borderRadius: 10,
      },

      [theme.breakpoints.up('tablet')]: {
        borderRadius: 15,
      },

      transition: 'background-color 0.3s ease-in-out',
    },
  },
  radioLabel: {
    '&&': {
      lineHeight: 1.33,

      color: theme.palette.custom.grey2,

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.s,
        fontWeight: FONTS.WEIGHTS.light,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xs,
        fontWeight: FONTS.WEIGHTS.medium,
      },
    },
  },
  impactWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACES.xs,
  },
  inputList: {
    '&&': {
      scrollbarWidth: '3px',
      scrollbarColor: `${theme.palette.custom.grey2} ${theme.palette.custom.grey2}`,
      '&::-webkit-scrollbar': {
        width: '3px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.custom.grey2,
        borderRadius: '10px',
      },
    },
  },
}))
